var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8961 18.8991C31.2279 18.7225 31.5068 18.4512 31.7018 18.1157C31.8967 17.7802 32 17.3937 32 16.9994C32 16.6051 31.8967 16.2186 31.7018 15.8831C31.5068 15.5476 31.2279 15.2763 30.8961 15.0996L2.89505 0.224615C2.54786 0.0400454 2.15762 -0.0331805 1.77193 0.0138699C1.38624 0.0609203 1.02177 0.226213 0.72299 0.489584C0.42421 0.752956 0.204033 1.10302 0.0893154 1.49707C-0.0254021 1.89113 -0.0297013 2.31214 0.0769443 2.70874L2.93505 13.3337C3.0546 13.7778 3.30707 14.1684 3.65425 14.4464C4.00142 14.7244 4.42439 14.8746 4.85912 14.8744L14.0015 14.8744C14.5319 14.8744 15.0406 15.0983 15.4157 15.4968C15.7908 15.8953 16.0015 16.4358 16.0015 16.9994C16.0015 17.563 15.7908 18.1035 15.4157 18.502C15.0406 18.9005 14.5319 19.1244 14.0015 19.1244L4.85912 19.1244C4.42439 19.1241 4.00142 19.2744 3.65425 19.5523C3.30707 19.8303 3.0546 20.2209 2.93505 20.665L0.0789422 31.29C-0.027917 31.6865 -0.0238734 32.1074 0.0905732 32.5015C0.20502 32.8956 0.424928 33.2458 0.723473 33.5094C1.02202 33.7729 1.3863 33.9385 1.7719 33.9859C2.1575 34.0333 2.54775 33.9605 2.89505 33.7763L30.8961 18.9013L30.8961 18.8991Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5cc05986cf306ae5d4ce38bf6fdc3def.svg";
export { ForwardRef as ReactComponent };